import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ForgotPasswordForm from './ForgotPasswordForm'
import Well from '../common/Well'
import PromoBanner from '../common/PromoBanner'
import Footer from '../layout/Footer'
import { forgotPassword, clearPasswordResetState, clearLoginError } from '../../actions/login'
import { validateForgotPassword } from '../../utils/validators'
import adLeaderImage from '../../../assets/images/login_banner.jpg'
import styles from './common.module.css'

function ForgotPassword({ appName, inProgress, error, forgotPasswordSent, forgotPassword, clearPasswordResetState, clearLoginError }) {
  const [email, setEmail] = useState('')
  const [validationErrors, setValidationErrors] = useState({})

  const role = appName === 'Admin' ? 'admin' : 'retailer'

  useEffect(() => {
    clearLoginError()
    return () => {
      clearPasswordResetState()
    }
  }, [])

  const handleEmailChange = event => {
    const val = event.target.value
    if (validationErrors.email) {
      setValidationErrors({})
    }
    setEmail(val)
  }

  const handleSubmit = () => {
    const { valid, error: valErr } = validateForgotPassword({ email })
    if (!valid) {
      setValidationErrors(valErr)
      return
    }
    setValidationErrors({})
    forgotPassword(email, role)
  }

  const mergedError = { ...validationErrors, message: error && error.message }

  return (
    <div id="extr-page">
      <header id="header" className={styles.header}>
        <div className={styles.headerWrapper}>
          <div className={styles.logo} />
          <h1 className={styles.appName}>
            {appName}
          </h1>
        </div>
      </header>

      <div id="main" role="main" className={styles.main}>
        <div className={styles.form}>
          <Well className="no-padding">
            <ForgotPasswordForm
              onEmailChange={handleEmailChange}
              inProgress={inProgress}
              error={mergedError}
              onSubmit={handleSubmit}
              sent={forgotPasswordSent}
            />
          </Well>
        </div>
      </div>

      <PromoBanner
        className={styles.ad}
        imgSrc={adLeaderImage}
        // url="https://mydiamond.app.link/login_leader"
      />

      <Footer />
    </div>
  )
}

const mapStateToProps = ({ login }) => ({
  inProgress: login.get('inProgress'),
  error: login.get('error') || {},
  forgotPasswordSent: login.get('forgotPasswordSent')
})

const mapDispatchToProps = {
  forgotPassword,
  clearPasswordResetState,
  clearLoginError
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
